import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  ActivityLikeBulkEditInput,
  TravelDirectionEnum,
} from '@wilson/activities/symbols';
import { ActivityTemplate } from '@wilson/interfaces';
import { NewWilsonJobBucketState } from '@wilson/share/state';
import { isBefore } from 'date-fns';

export type TransformableActivityTemplate = Pick<
  ActivityTemplate,
  | 'id'
  | 'agreementId'
  | 'activityTemplateQualificationsV2'
  | 'professionId'
  | 'jobActivityTemplates'
  | 'shiftSeriesId'
  | 'serviceSeries'
  | 'numberOfWagons'
  | 'tonnage'
  | 'vehicleEmissionClassId'
  | 'travelDirection'
  | 'organizationalUnitTransportGoodsId'
  | 'cargo'
  | 'track'
  | 'note'
  | 'orderNumber'
  | 'wagonNumber'
  | 'locomotiveNumber'
  | 'externalNumber'
>;

@Injectable({
  providedIn: 'root',
})
export class TransformActivityTemplateToActivityLikeService {
  private readonly store = inject(Store);

  transform(
    activityTemplates: TransformableActivityTemplate[],
    commentFromService: string | null,
  ): ActivityLikeBulkEditInput[] {
    return (
      activityTemplates
        ?.filter((activityTemplate) => activityTemplate.id)
        ?.map((activityTemplate) =>
          this.transformActivityTemplate(activityTemplate, commentFromService),
        ) || []
    );
  }

  private transformActivityTemplate(
    activityTemplate: TransformableActivityTemplate,
    commentFromService: string | null,
  ): ActivityLikeBulkEditInput {
    return {
      id: activityTemplate.id as string,
      agreementId: activityTemplate.agreementId || null,
      qualificationIds: (activityTemplate.activityTemplateQualificationsV2?.map(
        (activityTemplateQualification) =>
          activityTemplateQualification.qualificationId,
      ) || []) as string[],
      professionId: activityTemplate.professionId || null,
      numberOfWagons: activityTemplate.numberOfWagons || null,
      tonnage: activityTemplate.tonnage || null,
      vehicleEmissionClassId: activityTemplate.vehicleEmissionClassId || null,
      organizationalUnitTransportGoodsId:
        activityTemplate.organizationalUnitTransportGoodsId || null,
      travelDirection:
        (activityTemplate.travelDirection as TravelDirectionEnum) || null,
      share:
        !!activityTemplate.jobActivityTemplates?.length ||
        !!activityTemplate.shiftSeriesId ||
        (activityTemplate.serviceSeries?.validTill &&
          isBefore(
            new Date(activityTemplate.serviceSeries.validTill),
            new Date(),
          )) ||
        this.store.selectSnapshot(
          NewWilsonJobBucketState.doesIdExistInBucket(
            activityTemplate.id as string,
          ),
        ),
      cargo: activityTemplate.cargo,
      track: activityTemplate.track,
      externalNumber: activityTemplate.externalNumber,
      note: activityTemplate.note || commentFromService,
      orderNumber: activityTemplate.orderNumber || null,
      wagonNumber: activityTemplate.wagonNumber || null,
      locomotiveNumber: activityTemplate.locomotiveNumber || null,
    };
  }
}
